export var Role;
(function (Role) {
    /** Undefined group member role. */
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    /** Regular group member. */
    Role["MEMBER"] = "MEMBER";
    /** Group administrator. */
    Role["ADMIN"] = "ADMIN";
})(Role || (Role = {}));
export var JoinBy;
(function (JoinBy) {
    JoinBy["MANUALLY"] = "MANUALLY";
    JoinBy["PERSONAL_INVITE_LINK"] = "PERSONAL_INVITE_LINK";
    JoinBy["PUBLIC_INVITE_LINK"] = "PUBLIC_INVITE_LINK";
})(JoinBy || (JoinBy = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var MembershipStatus;
(function (MembershipStatus) {
    /** Undefined membership status. */
    MembershipStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Site member is a group member. */
    MembershipStatus["JOINED"] = "JOINED";
    /** Site member has submitted a request to join this group. The request is still `PENDING`. */
    MembershipStatus["PENDING"] = "PENDING";
})(MembershipStatus || (MembershipStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map